// extracted by mini-css-extract-plugin
module.exports = {"container":"gamesheadercard_container__8V90F"};